import { render } from "./LangIcon.vue?vue&type=template&id=13f32ad6&scoped=true"
import script from "./LangIcon.vue?vue&type=script&lang=js"
export * from "./LangIcon.vue?vue&type=script&lang=js"

import "./LangIcon.vue?vue&type=style&index=0&id=13f32ad6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f32ad6"]])

export default __exports__